import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#2D372B] text-[#E6DFD3] mt-24" data-testid="site-footer">
      <div className="px-6 md:px-12 lg:px-20 mx-auto max-w-7xl py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <img src="/wayside/logo-cream.png" alt="Wayside Orchard" className="h-12 w-auto" />
          <p className="mt-3 kicker text-[#D4A373]">Est. 2019</p>
          <p className="mt-4 text-sm leading-relaxed text-[#A9B3A4] max-w-xs">
            The way things were, and will be. Small batch, hand made goods from our little orchard to your table.
          </p>
        </div>
        <div>
          <p className="kicker text-[#D4A373]">Explore</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/shop" className="hover:text-white transition-colors">Shop</Link></li>
            <li><Link to="/our-story" className="hover:text-white transition-colors">Our Story</Link></li>
            <li><Link to="/admin" className="hover:text-white transition-colors">Store Login</Link></li>
          </ul>
        </div>
        <div>
          <p className="kicker text-[#D4A373]">Visit</p>
          <p className="mt-4 text-sm leading-relaxed text-[#A9B3A4]">
            Pull over, get off the highway of life, and refill your proverbial cup.
          </p>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-[#A9B3A4]">
        © {new Date().getFullYear()} Wayside Orchard. All rights reserved.
      </div>
    </footer>
  );
}
